;(function () {
  angular
    .module('contrast.settings.ip', [
      'ngRoute',
      'ngAnimate',
      'route-segment',
      'view-segment',
      'ui.bootstrap'
    ])
    .controller('IPSettingsCtrl', IPSettingsCtrl)

  function IPSettingsCtrl(
    $scope,
    $q,
    logger,
    SecurityFactory,
    ProfileService,
    ErrorService,
    $uibModal
  ) {
    'ngInject'

    var vm = this

    var originalIpRanges = []

    angular.extend(vm, {
      ipRangesPromise: null,
      model: {},
      organization: {
        iprange: []
      },
      blankIpRange: { ip: '' },
      currentIpAddress: ''
    })

    angular.extend(vm, {
      save: save,
      preSave: preSave,
      addIpRange: addIpRange,
      removeIpRange: removeIpRange
    })

    function _init() {
      _getIPRanges().then(maybeAddEmptyInnerForm)
      _getUserIPAddress()
    }

    var modalPopup = function () {
      return ($scope.modalInstance = $uibModal.open({
        templateUrl: 'views/settings/security/ip-warning-modal.html',
        scope: $scope
      }))
    }

    $scope.openModalPopup = function () {
      modalPopup()
        .result.then(function () {
          // placeholder to avoid unhandled rejection
        })
        .then(null, function () {
          // placeholder to avoid unhandled rejection
        })
    }

    $scope.cancel = function () {
      $scope.modalInstance.dismiss()
    }

    function ipToInt(ip) {
      return (
        ip.split('.').reduce(function (int, octet) {
          return (int << 8) + parseInt(octet, 10)
        }, 0) >>> 0
      )
    }

    function cidrToRange(cidr) {
      var parts = cidr.split('/')
      var subnet = parts[0]
      var bits = parseInt(parts[1], 10)
      var mask = ~(Math.pow(2, 32 - bits) - 1)
      var start = ipToInt(subnet) & mask
      var end = (start + ~mask) >>> 0
      return [start, end]
    }

    function isIpInRange(ip, cidr) {
      var ipInt = ipToInt(ip)
      var range = cidrToRange(cidr)
      var start = range[0]
      var end = range[1]
      return ipInt >= start && ipInt <= end
    }

    function preSave() {
      if (vm.currentIpAddress) {
        var currentIpAddress = vm.currentIpAddress
        var ipRanges = vm.organization.iprange.map(function (ipRange) {
          return ipRange.ip
        })
        var hasRangesDefined = ipRanges.length > 1 || ipRanges[0] !== ''
        var currentIpInAllowlist = ipRanges.some(function (ipRange) {
          return isIpInRange(currentIpAddress, ipRange)
        })

        if (hasRangesDefined && !currentIpInAllowlist) {
          $scope.openModalPopup()
        } else {
          save()
        }
      }
    }

    function save() {
      // Compare new list to old list
      var ipRangesToDelete = []
      _.forEach(originalIpRanges, function (ipRange) {
        if (_.findIndex(vm.organization.iprange, { ip: ipRange.ip }) === -1) {
          ipRangesToDelete.push(ipRange)
        }
      })

      _deleteIPRanges(ipRangesToDelete)
        .then(_saveIPRanges)
        .then(_getIPRanges)
        .then(maybeAddEmptyInnerForm)
        .catch(ErrorService.processError)

      $scope.form.$setPristine()
    }

    function maybeAddEmptyInnerForm() {
      if (vm.organization.iprange.length === 0) {
        vm.organization.iprange.push(angular.copy(vm.blankIpRange))
      }
    }

    function addIpRange() {
      $scope.form.$setDirty()
      vm.organization.iprange.push(angular.copy(vm.blankIpRange))
    }

    function removeIpRange(ipRange) {
      $scope.form.$setDirty()
      if (vm.organization.iprange.length === 1) {
        vm.organization.iprange[0] = angular.copy(vm.blankIpRange)
      } else {
        vm.organization.iprange.splice(
          vm.organization.iprange.indexOf(ipRange),
          1
        )
      }
    }

    function _getIPRanges() {
      vm.ipRangesPromise = SecurityFactory.getIPRanges()
        .then(function (response) {
          var data = response.data
          vm.organization.iprange = []
          _.forEach(data.ipRanges, function (ip) {
            vm.organization.iprange.push({ ip: ip })
          })
          originalIpRanges = angular.copy(vm.organization.iprange)
        })
        .catch(ErrorService.processError)
      return vm.ipRangesPromise
    }

    function _getUserIPAddress() {
      const user = ProfileService.getUser()
      vm.currentIpAddress = user.ip_address
    }

    function _saveIPRanges() {
      var ipRanges = []
      _.forEach(vm.organization.iprange, function (ipRange) {
        if (ipRange.ip !== '') {
          ipRanges.push(ipRange.ip)
        }
      })

      if (ipRanges.length > 0) {
        return SecurityFactory.addIPRanges(ipRanges).then(function (response) {
          var data = response.data
          logger.logSuccess(data.messages[0])
        })
      }
    }

    function _deleteIPRanges(ipRangesToDelete) {
      const ipRanges = ipRangesToDelete.map((ipAddress) => ipAddress.ip)
      if (ipRanges.length === 0) {
        // Return a resolved promise if there are no IP ranges to delete
        return $q.resolve()
      }

      return SecurityFactory.deleteIPRange(ipRanges)
    }

    _init()
  }
})()
